import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { useDispatch, useSelector } from 'react-redux'

import {
  Tabs,
  ActionBar,
  APDataTable,
  ARDataTable,
  TableHeader,
} from '../../components/accounting-dashboard'
import { Loading } from '../../components/loading'
import { authAction, accountingAction } from '../../actions'
import { accountingSelector, authSelector } from '../../selectors'
import withLayout from '../../helpers/withLayout'
import { SimpleModal } from '../../components/modal/simple-modal'
import { modalButtons } from '../../components/buttons/modal-button'

const AccountingDashBoardPage = props => {
  const access_token = localStorage.getItem('access_token')
  const dispatch = useDispatch()
  const [activeTab, setActiveTab] = useState(0)
  const [sortOrderAP, setSortOrderAP] = useState({ col: 'start_date', desc: true })
  const [sortOrderAR, setSortOrderAR] = useState({ col: 'invoice_date', desc: true })

  const isLoading = useSelector(accountingSelector.getIsFetching)
  const accountingState = useSelector(accountingSelector.getAccounting)
  const responseModal = accountingState.responseModal

  const authData = useSelector(authSelector.getAuth)
  const redirectAuth = useSelector(authSelector.redirectAuth)

  useEffect(() => {
    fetchData()
    return () => Promise.all([
      dispatch(accountingAction.setAPFilter({ apFilter: {
        deliveryStateDate: null,
        deliveryEndDate: null,
        dueStartDate: null,
        dueEndDate: null,
        status: 0,
      } })),
      dispatch(accountingAction.setARFilter({ arFilter: {
        dueStartDate: null,
        dueEndDate: null,
        status: 0,
      } })),
    ])
  }, [])

  useEffect(() => {
    if (redirectAuth) {
      const isAuthenticated = redirectAuth.isAuthenticated
      const redirect = redirectAuth.redirect
      if (redirect) {
        localStorage.clear()
        if (isAuthenticated) localStorage.setItem('bad_token', true)
        dispatch(authAction.resetAuth())
        window.location = '/'
      }
    }
    if (authData && authData.user) {
      const isSystemAdmin = authData.user.is_system_admin
      const isManagementRole = authData.user.is_management_role
      const isAccountantRole = authData.user.is_accountant_role
      if (!(isSystemAdmin || isAccountantRole || isManagementRole)) window.location = '/home'
    }
  }, [authData, redirectAuth])

  const fetchData = async () => {
    await dispatch(authAction.auth(access_token))
  }

  const handleSort = (tab, col) => {
    if (tab === 'ap') {
      if (sortOrderAP.col === col) {
        setSortOrderAP({ ...sortOrderAP, desc: !sortOrderAP.desc })
      } else {
        setSortOrderAP({ tab, col, desc: true })
      }
    } else if (tab === 'ar') {
      if (sortOrderAR.col === col) {
        setSortOrderAR({ ...sortOrderAR, desc: !sortOrderAR.desc })
      } else {
        setSortOrderAR({ tab, col, desc: true })
      }
    }
  }

  const openDiscardModal = actions => {
    dispatch(accountingAction.openResponseModal({
      responseModal: {
        isOpen: true,
        res: {
          title: 'Unsaved changes',
          description: 'Are you sure you want to discard these changes?',
          actions: modalButtons('discard', actions),
        },
      },
    }))
  }

  const closeResponseModal = () => {
    dispatch(accountingAction.openResponseModal({ responseModal: { isOpen: false, res: {} } }))
  }

  const handleChangeTab = tab => {
    setActiveTab(tab)
  }

  const goToProjectInfo = id => {
    props.history.push({
      pathname: `project_information/${id}`,
      state: {
        header: 'Project Information',
        activeTab: '4',
      },
    })
  }

  return (
    <Root>
      <Loading isLoading={ isLoading } />
      <SimpleModal
        isOpen={ responseModal.isOpen }
        toggle={ closeResponseModal }
        { ...responseModal.res }
      />
      <Wrapper>
        <Tabs
          activeTab={ activeTab }
          handleChangeTab={ handleChangeTab }
        />
        <ActionBar activeTab={ activeTab } />
      </Wrapper>
      <TableWrapper>
        <TableHeader
          activeTab={ activeTab }
          sortOrderAP={ sortOrderAP }
          sortOrderAR={ sortOrderAR }
          handleSort={ handleSort }
        />
        { activeTab === 0 ?
          <APDataTable
            sortOrder={ sortOrderAP }
            openDiscardModal={ openDiscardModal }
            closeResponseModal={ closeResponseModal }
          />
          :
          <ARDataTable
            sortOrder={ sortOrderAR }
            openDiscardModal={ openDiscardModal }
            closeResponseModal={ closeResponseModal }
            goToProjectInfo={ goToProjectInfo }
          />
        }
      </TableWrapper>
    </Root>
  )
}

export default withLayout(AccountingDashBoardPage)

const Root = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`

const Wrapper = styled.div`
  position: sticky;
  top: 0;
  z-index: 1;
  background: #F9F9F9;
`

const TableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  @media (max-width: 1440px) {
    overflow-x: auto;
  }
`



// WEBPACK FOOTER //
// ./src/pages/accounting-dashboard/index.js